import { CustomerVariables } from '../../customerVariables/variable_interfaces';
import { getCustomerVariables } from '../../features/context/CustomerContextHelper';
import { UserInfo, UserInfoFromJSON } from '../models/UserInfo';
import { UserRepresentation, UserRepresentationFromJSON } from '../models/UserRepresentation';
import * as runtime from '../runtime';

export class UsersApi extends runtime.BaseAPI {

    readonly customerVariables: CustomerVariables = getCustomerVariables();

    async changeLocale(locale: string) {
        const response = await this.getCurrentUser();
        const keycloakUser: UserRepresentation = await response.value();
        
        let newAttributes = {...keycloakUser.attributes, locale: [locale]};
        let updatedUser = {...keycloakUser, attributes: newAttributes};

        await this.updateCurrentUser(updatedUser);
    }

    async getUserProfile(): Promise<UserRepresentation> {
        const response = await this.getCurrentUser();
        return await response.value();
    }

    async getCurrentUser(): Promise<runtime.ApiResponse<UserRepresentation>> {
        const headerParameters: runtime.HTTPHeaders = {};
        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/realms/${this.customerVariables.realmName}/account`,
            method: 'GET',
            headers: headerParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => UserRepresentationFromJSON(jsonValue));
    }

    async getCurrentUserInfo(): Promise<UserInfo> {
        const response = await this.getUserInfo();
        return await response.value();
    }

    async getUserInfo(): Promise<runtime.ApiResponse<UserInfo>> {
        const headerParameters: runtime.HTTPHeaders = {};
        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/realms/${this.customerVariables.realmName}/protocol/openid-connect/userinfo`,
            method: 'GET',
            headers: headerParameters
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => UserInfoFromJSON(jsonValue));
    }

    async updateCurrentUser(user: any): Promise<runtime.ApiResponse<void>> {
        if(user === null || user === undefined){
            throw new runtime.RequiredError('user', 'Required parameter user was null or undefined when calling update.');
        }

        const headerParameters: runtime.HTTPHeaders = {};
        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/realms/${this.customerVariables.realmName}/account`,
            method: 'POST',
            headers: headerParameters,
            body: user
        });

        return new runtime.VoidApiResponse(response);
    }
}